import logo from './images/IDS-Logo_Icon.png';
import logoWord from './images/IDS-Logo_Word.png';

// Set via .env.development / .env.production. Prod URL retained as a fallback
// so a missing env var in CI still produces a working prod build.
const baseUrl = process.env.REACT_APP_API_URL || 'https://caas-api.informationdiscovery.net/';

const disclaimer = 'Access to this page is restricted to Information Discovery Services authorized personnel only. Do not attempt to log into this site without prior authentication.';
const version = '1.0.0hf-hub';
export { baseUrl, logo, logoWord, disclaimer, version };
